import s from "./Iframe.module.scss"

// The iframe that we use to embed most of our products in Portal

type IframeProps = {
  src?: string | undefined
  permissions?: string[]
}
export const Iframe = ({ src, permissions = [] }: IframeProps) => {
  const allow = [
    /**
     * We explicitly disable autoplay for videos in PORTAL to not run into issues
     * with browser restrictions, but we keep this directive, as it justs says
     * if it's allowed, not that it should be used.
     *
     * https://developer.mozilla.org/en-US/docs/Web/HTTP/Reference/Headers/Permissions-Policy/autoplay
     */
    "autoplay",

    /**
     * https://developer.mozilla.org/en-US/docs/Web/API/Encrypted_Media_Extensions_API
     */
    "encrypted-media",

    /**
     * Additional Permissions Policy directives to be allowed in the iframe.
     * https://developer.mozilla.org/en-US/docs/Web/HTTP/Reference/Headers/Permissions-Policy#directives
     */
    ...permissions,
  ].join("; ")

  return (
    <iframe
      className={s.iframe}
      src={src}
      title="Attensi product viewer"
      allow={allow}
      allowFullScreen
    />
  )
}
